// 购物车
<template>
  <div class="shoppingCart">
      购物车
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>